import { useState } from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PreferenceSetting from "./preferenceSetting";
import DocumentationSetting from "./documentationSetting";
import AcademicYearList from "../academicYear/academicYearList";
import EvaluationPeriodList from "../evaluationPeriod/evaluationPeriodList";
import LevelTypeList from "../leveltype";
import CycleList from "../cycle";
import ParcoursList from "../parcours";
import DiplomeSettings from "../diplome";

const Settings = () => {
  const [settingPage, setSettingPage] = useState("methodCalcul");

  return (
    <>
      <div className="page-wrapper">
        <div className="content bg-white">
          <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Paramètres</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index">Année Universitaire</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Paramètres</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Méthode de Calcul
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="pe-1 mb-2">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Rafraîchir</Tooltip>}
                >
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white btn-icon me-1"
                  >
                    <i className="ti ti-refresh" />
                  </Link>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-2 col-xl-3">
              <div className="pt-3 d-flex flex-column list-group mb-4">
                <Link
                  to="#"
                  className={`d-block rounded p-2 ${settingPage === "methodCalcul" && "active"}`}
                  onClick={() => setSettingPage("methodCalcul")}
                >
                  Préferences
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("documentation")}
                  className={`d-block rounded p-2 ${settingPage === "documentation" && "active"}`}
                >
                  Documentation
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("academicYear")}
                  className={`d-block rounded p-2 ${settingPage === "academicYear" && "active"}`}
                >
                  Année Universitaire
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("evaluationPeriod")}
                  className={`d-block rounded p-2 ${settingPage === "evaluationPeriod" && "active"}`}
                >
                  Période d'évaluation
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("parcours")}
                  className={`d-block rounded p-2 ${settingPage === "parcours" && "active"}`}
                >
                  Parcours d'étude
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("diplome")}
                  className={`d-block rounded p-2 ${settingPage === "diplome" && "active"}`}
                >
                  Diplômes / Décision
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("levelType")}
                  className={`d-block rounded p-2 ${settingPage === "levelType" && "active"}`}
                >
                  Type de niveau
                </Link>
                <Link
                  to="#"
                  onClick={() => setSettingPage("cycle")}
                  className={`d-block rounded p-2 ${settingPage === "cycle" && "active"}`}
                >
                  Cycle
                </Link>
              </div>
            </div>
            <div className="col-xxl-10 col-xl-9">
              <div className="border-start ps-3 mt-4">
                {settingPage === "methodCalcul" ? (
                  <PreferenceSetting />
                ) : settingPage === "documentation" ? (
                  <DocumentationSetting />
                ) : settingPage === "academicYear" ? (
                  <AcademicYearList />
                ) : settingPage === "evaluationPeriod" ? (
                  <EvaluationPeriodList />
                ) : settingPage === "cycle" ? (
                  <CycleList />
                ) : settingPage === "parcours" ? (
                  <ParcoursList />
                ) : settingPage === "levelType" ? (
                  <LevelTypeList />
                ) : settingPage === "diplome" ? (
                  <DiplomeSettings />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
